import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: Readonly<ClassValue[]>) {
  return twMerge(clsx(inputs));
}
